import { c as _c } from "react/compiler-runtime";
export function EllipsisIcon(props) {
  const $ = _c(12);
  let rest;
  let t0;
  if ($[0] !== props) {
    ({
      fill: t0,
      ...rest
    } = props);
    $[0] = props;
    $[1] = rest;
    $[2] = t0;
  } else {
    rest = $[1];
    t0 = $[2];
  }
  const fill = t0 === undefined ? "#000000" : t0;
  let t1;
  let t2;
  let t3;
  if ($[3] !== fill) {
    t1 = <path d="M16.0416 14C16.0416 15.1276 15.1275 16.0417 14 16.0417C12.8724 16.0417 11.9583 15.1276 11.9583 14C11.9583 12.8724 12.8724 11.9583 14 11.9583C15.1275 11.9583 16.0416 12.8724 16.0416 14Z" fill={fill} />;
    t2 = <path d="M24.2083 14C24.2083 15.1276 23.2942 16.0417 22.1666 16.0417C21.039 16.0417 20.125 15.1276 20.125 14C20.125 12.8724 21.039 11.9583 22.1666 11.9583C23.2942 11.9583 24.2083 12.8724 24.2083 14Z" fill={fill} />;
    t3 = <path d="M7.87496 14C7.87496 15.1276 6.96087 16.0417 5.83329 16.0417C4.70571 16.0417 3.79163 15.1276 3.79163 14C3.79163 12.8724 4.70571 11.9583 5.83329 11.9583C6.96087 11.9583 7.87496 12.8724 7.87496 14Z" fill={fill} />;
    $[3] = fill;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
  }
  let t4;
  if ($[7] !== rest || $[8] !== t1 || $[9] !== t2 || $[10] !== t3) {
    t4 = <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>{t1}{t2}{t3}</svg>;
    $[7] = rest;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}